// Shared by the community editors and CommunityContentRenderer, so a draft looks like the published post.
export const COMMUNITY_NODE_CLASS_NAMES = {
  heading: 'font-semibold mb-4',
  bulletList: 'list-disc pl-6 mb-4',
  orderedList: 'list-decimal pl-6 mb-4',
  listItem: 'mb-2',
  blockquote: 'border-l-4 border-black/20 pl-4 mb-4',
};
